<app-loader></app-loader>
<app-menu></app-menu>
<router-outlet></router-outlet>
<app-mobile-alert></app-mobile-alert>
